import React from 'react';
import { observer } from 'mobx-react';
import ApprovalSwitcher from '../Components/ApprovalSwitcher';
import ActionSelect from '../Components/ActionSelect';
import WhenButtonGroup from '../Components/WhenButtonGroup';
import { SideBarSection } from '../StepSideBar/StepSideBar.styles';
import StaticProTip from '../Components/StaticProTip';
import { useRootStore } from '~/stores/useRootStore';
import styled from 'styled-components';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';
import AutomationTriggerFilters from '~/components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/AutomationTriggerFilters';
import PipelineStageSelect from '~/components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/Components/PipelineStageSelect';

const PipelineStageSideBar = () => {
    const {
        automationUiStore: {
            selectedStep: { isApprovalRequired, updateSelectedStage }
        },
        companyStore: {
            currCompany: { user_pipeline_stages }
        }
    } = useRootStore();

    const { t } = useTranslation(NAMESPACES.AUTOMATIONS);

    const onSelectStage = stageId => {
        const selectedStage = user_pipeline_stages.find(s => s._id === stageId);
        updateSelectedStage(selectedStage);
    };
    return (
        <>
            <SideBarSection>
                <ActionSelect />
            </SideBarSection>

            <SideBarSection>
                <PipelineStageSelect
                    onSelectStage={onSelectStage}
                    options={user_pipeline_stages}
                    type="pipeline"
                />
            </SideBarSection>
            <SideBarSection>
                <WhenButtonGroup />
                <AutomationTriggerFilters />
                <ApprovalSwitcher isPipelineStage={true} />
                {isApprovalRequired && (
                    <AssignToTeamMemberCaption
                        type="caption12"
                        color="neutral700"
                    >
                        {t('sidebar.task_assigned_email')}
                    </AssignToTeamMemberCaption>
                )}
            </SideBarSection>
            <StaticProTip />
        </>
    );
};

export default observer(PipelineStageSideBar);

// -------------------------------- Styles -------------------------------- //

const AssignToTeamMemberCaption = styled(HBText)`
    display: flex;
`;
